import { AsyncEffectHandle, useAsyncEffectGenerator } from './async-effect'

/**
 * Use this hook to declare a repeatable async function call.
 * Returns the loading state and any error thrown from the action.
 *
 * NOTE: This hook is almost just a proxy to the async effect handle
 *  in order to simplify usage, provide documentation, and facilitate easier refactoring.
 *
 * @param {Function<void>} action the action handler
 * @returns {AsyncEffectHandle} a handle array with capabilities in the following order:
 *  0=loading, 1=error, 2=repeat
 */
export const useAction = <A extends any[], R>(
    action: (...args: A) => Promise<R | undefined>
): AsyncEffectHandle<typeof action> => useAsyncEffectGenerator(action, false)
